// @ts-nocheck
import { useQueryClient, useMutation } from 'react-query';
import { useRequestQuery } from '../useQueryRequest';
import useApiRequest from '../useRequest';
import t from './types';

/**
 * Retrive the month-end closing months list.
 */
export function useMonthEndClosing(props) {
  return useRequestQuery(
    [t.MONTH_END_CLOSING],
    { method: 'get', url: 'month-end-closing' },
    {
      select: (res) => res.data.data,
      defaultData: [],
      ...props,
    },
  );
}

/**
 * Close an accounting month.
 */
export function useCloseMonth(props) {
  const queryClient = useQueryClient();
  const apiRequest = useApiRequest();

  return useMutation((values) => apiRequest.post('month-end-closing/close', values), {
    onSuccess: () => {
      queryClient.invalidateQueries(t.MONTH_END_CLOSING);
    },
    ...props,
  });
}

/**
 * Reopen the latest closed accounting month.
 */
export function useReopenMonth(props) {
  const queryClient = useQueryClient();
  const apiRequest = useApiRequest();

  return useMutation((values) => apiRequest.post('month-end-closing/reopen', values), {
    onSuccess: () => {
      queryClient.invalidateQueries(t.MONTH_END_CLOSING);
    },
    ...props,
  });
}
